export const BUSINESS_FUND_TRANSFER = [
  { labelText: 'Personal funds', id: 'PERSONAL FUNDS' },
  { labelText: 'Family funds', id: 'FAMILY FUNDS' },
  { labelText: 'Financed: non-financial institution', id: 'FINANCEDNON-FINANCIALINS' },
  { labelText: 'Financed', id: 'FINANCED' }
];

export const COST_TO_START_BUSINESS = [
  { labelText: '£0 - £2500', id: '0-2500' },
  { labelText: '£2500 - £5000', id: '2500-5000' },
  { labelText: '£5000 - £10000', id: '5000-10000' },
  { labelText: '£10000 or more', id: '10000 OR More' }
];

export const getLabelByKey = (key, data) => {
  if (key) {
    const currentData = data ? data : BUSINESS_FUND_TRANSFER;
    const funds = currentData.filter((v) => v.id === key);
    return funds ? funds[0].labelText : '';
  }
  return '';
};
